import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Environment} from '../../shared/environment/environment';
import {Cached} from '@ngx-cache/core';
import {PackColors} from '../../model/dam/packcolors';
import {CacheConstants} from '../../shared/cache-constants';
import {map} from 'rxjs/operators';
import {TvshopConstants} from '../../shared/tvshop-constants';
import {LanguageService} from '../language/language.service';
import {Trailer} from '../../model/dam/trailer';
import {OmapiIdsUtils} from '../../shared/utils/omapi-ids/omapi-ids-utils';


@Injectable()
export class ResourceService {

  constructor(private httpClient: HttpClient,
              private languageService: LanguageService) {
  }

  public getColourForProduct(omapiId: string): Observable<string> {
    return this.getColoursForProducts()
      .pipe(map<PackColors, string>(packColors => {
        const colorFromFile = packColors.packcolors.find(color => {
          return color.omapiid === omapiId;
        });

        if (!colorFromFile) {
          return 'none';
        }
        return colorFromFile.color;
      }));
  }

  @Cached(CacheConstants.COLOR_FOR_PRODUCTS)
  public getColoursForProducts(): Observable<PackColors> {
    return this.httpClient
      .get<PackColors>(this.getBaseUrl() + '/telenet/data/product/colors');
  }

  public getLogoUrl(packOmapiId: string, subPackOmapiId: string, isDaypass?: boolean) {
    if (isDaypass) {
      const language = this.languageService.getCurrentLanguage();
      return Environment.environmentConfig().baseUrl + TvshopConstants.IMAGES_AEM_PATH + OmapiIdsUtils.getCorrectIdForResource(packOmapiId) + '-logo-' + language + '.png';
    }
    if (subPackOmapiId) {
      return Environment.environmentConfig().baseUrl + TvshopConstants.IMAGES_AEM_PATH + OmapiIdsUtils.getCorrectIdForResource(packOmapiId) + '-'
        + OmapiIdsUtils.getCorrectIdForResource(subPackOmapiId) + '-logo.png';
    }
    return Environment.environmentConfig().baseUrl + TvshopConstants.IMAGES_AEM_PATH + OmapiIdsUtils.getCorrectIdForResource(packOmapiId) + '-logo.png';
  }

  private getBaseUrl(): string {
    return Environment.environmentConfig().baseUrl;
  }

}
